// Sagas are middleware that describe asynchronous actions or side effects in
// the app - for example, creating a new schedule or getting a list of schedules
// from the server. Sagas either run at init or listen for actions to initiate
// asynchronous behaviors. Sagas are an alternative to thunks and other
// async middleware commonly used in Redux docs and tutorials.
//
// NOTE: Don't put side effects in actions, reducers, or components! Keep side
// effects in sagas or utility functions used by sagas.
//
// https://yelouafi.github.io/redux-saga/
import createSagaMiddleware, {takeEvery} from 'redux-saga';
import dataSagas from './data';
import calculatorSagas from './calculator';
import analyzeSagas from './analyze';
import bespokeSagas from './bespoke';
import authSagas from './auth';
import homeSagas from './home';
import adminSagas from './admin';
import messageSagas from './message';
import communicationsSagas from './communications';
import connectSagas from './connect';
import surveySagas from './survey';
import ilndashboardSagas from "./ilndashboard";
import solutionAllPrograms from "./solutionAllPrograms"
import solutionGoals from "./solutionGoals"
import solutionRecommended from "./solutionRecommended"
import solutionMySolutions from "./solutionMySolutions"
import solutionMySolutionsArchive from "./solutionMySolutionsArchive"
import * as Sentry from '@sentry/react';
import { initializeStore } from '../store'

const onError = (error) => {
    Sentry.captureException(error, {
        tags: {
            profile: initializeStore()?.getState()?.profile
        }
    });
};

// Saga middleware
export let sagaMiddleware = createSagaMiddleware({onError});

// Run all the sagas
export let sagas = [
    ...dataSagas,
    ...calculatorSagas,
    ...communicationsSagas,
    ...analyzeSagas,
    ...bespokeSagas,
    ...authSagas,
    ...homeSagas,
    ...adminSagas,
    ...messageSagas,
    ...connectSagas,
    ...surveySagas,
    ...ilndashboardSagas,
    ...solutionAllPrograms,
    ...solutionGoals,
    ...solutionMySolutions,
    ...solutionMySolutionsArchive,
    ...solutionRecommended
].map(createWatcher);

// For each action/saga pair, the action should trigger the saga each time
function createWatcher(actionSagaPair) {
    return function* () {
        yield* takeEvery(...actionSagaPair);
    };
}
